import { getBlogPageCopy } from "@/lib/blog-page-copy";
import type { Lang } from "@/lib/types";

type BlogCategoryLike = {
  slug?: string | Record<string, string>;
  name?: string | Record<string, string>;
};

function pickRecord(value: string | Record<string, string> | undefined, lang: Lang): string {
  if (!value) return "";
  if (typeof value === "string") return value;
  return value[lang] ?? value.en ?? Object.values(value)[0] ?? "";
}

/**
 * Display name for a blog category in the active language.
 *
 * Category names in `src/data/blog/lib/categories.json` are English-only, so the
 * per-slug translations in `src/data/copy/blog-page.json` → `categories` win;
 * the CMS name (including any CMS translations) is the fallback.
 */
export function getBlogCategoryLabel(category: BlogCategoryLike, lang: Lang): string {
  const slug = typeof category.slug === "string" ? category.slug.trim() : "";
  const translated = (getBlogPageCopy(lang).categories as Record<string, string | undefined>)[slug];
  return translated || pickRecord(category.name, lang);
}
